import { render } from "./watermark-page.vue?vue&type=template&id=6ea62d29&scoped=true&ts=true"
import script from "./watermark-page.vue?vue&type=script&lang=ts"
export * from "./watermark-page.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea62d29"]])

export default __exports__